import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/freight',
  validateSearch: (search: Record<string, unknown>): { queue?: string } => ({
    queue: typeof search.queue === 'string' && search.queue.length > 0 ? search.queue : undefined,
  }),
}).lazy(() => import('./index.lazy').then((d) => d.Route))
